document.addEventListener("DOMContentLoaded", function () {
  var lang = (document.documentElement.lang || "").toLowerCase();

  // Only run if language is German, Dutch, French, or Spanish.
  if (lang.startsWith("de") || lang.startsWith("nl") || lang.startsWith("fr") || lang.startsWith("es")) {
    // Define translation maps for different languages.
    var labelTranslations,
      tooltipTranslations,
      optionTranslations,
      ppdataTranslations,
      dropdownTranslations,
      buttonTranslations;

    // Frame color translations (visible text only – data-val stays as is)
    var frameColorTranslations;

    if (lang.startsWith("de")) {
      // German translations.
      labelTranslations = {
        "GAS LIFT": "GASFEDER",
        "WHEELS": "ROLLEN",
        "FABRIC": "BEZUG",
        "FRAME": "FUßKREUZ",
        "FOOTRING": "FUßRING",
        "COLOUR PLASTIC": "KUNSTSTOFFFARBE",
        "ARM RESTS": "ARMLEHNEN",
        
      };

      // NOTE:
      // Keep tooltipTranslations as TEXT translations.
      // The gas lift tooltip is an <a> element, so we update it separately (see translateTooltipLinks()).
      tooltipTranslations = {
        "Select your fabric below from a variety of options, including Cura, Extreme, Select, Capture, Paloma Leather, or Elmosoft Leather.":
          "Wählen Sie unten Ihren Bezug aus einer Vielzahl von Optionen, darunter Cura, Extreme, Select, Capture, Paloma Leather oder Elmosoft Leather.",
        "Which gas lift should I choose?": "Welche Gasfeder soll ich wählen?",
      };

      optionTranslations = {
        "Choose your fabric": "Wählen Sie Ihren Bezug",
        "Select (Gabriel) - Wool": "Select (Gabriel) - Wolle",
        "Capture (Gabriel) - Wool": "Capture (Gabriel) - Wolle",
        "Focus (Melange) (Gabriel) - Wool": "Focus (Melange) (Gabriel) - Wolle",
        "Mainline Flax (Camira) - Wool": "Mainline Flax (Camira) - Wolle",
        "PUxx 1 (Oniro) - Synthetic Leather": "PUxx 1 (Oniro) - Kunstleder",
        "Sirdal (GU) - Wool": "Sirdal (GU) - Wolle",
        "Steelcut (Kvadrat) - Wool": "Steelcut (Kvadrat) - Wolle",
        "Sisu (Kvadrat) - Wool": "Sisu (Kvadrat) - Wolle",
        "Paloma Soft (Wollsdorf) - Leather": "Paloma Soft (Wollsdorf) - Leder",
        "Elmosoft (Elmo) - Leather": "Elmosoft (Elmo) - Leder",
      };

      ppdataTranslations = {
        "Wheels for hard floors": "Rollen für harte Böden",
        "Wheels for soft floors": "Weichbodenrollen",
        "Glides": "Gleiter",
        "Universal Wheels": "Universalrollen",
        "No": "Ohne",
        "Yes": "Mit Fußring",
        "No Arm rests": "Keine Armlehnen",
        "Arm rests / Stable": "Armlehnen / Stabil",
        "Arm rests / Swingback": "Armlehnen / Swingback",
        "3D Arm rests / Stable": "3D-Armlehnen / Stabil",
        "3D Arm rests / Swingback": "3D-Armlehnen / Swingback",
      };

      dropdownTranslations = {
        "No": "Ohne",
        "Yes": "Ja",
        "No Arm rests": "Keine Armlehnen",
      };

      buttonTranslations = {
        "DESIGN YOUR OWN": "KONFIGURIEREN",
        "Back to Original Product": "Zurück zum Originalprodukt",
      };

      frameColorTranslations = {
        "Black": "Schwarz",
        "White": "Weiß",
        "Silver": "Silber",
        "Blush Rose": "Blush Rose",
        "Moss Grey": "Moss Grey",
        "Polished Alu": "Alu Poliert",
      };
    } else if (lang.startsWith("nl")) {
      // Dutch translations.
      labelTranslations = {
        "GAS LIFT": "GASLIFT",
        "WHEELS": "WIELEN",
        "FABRIC": "STOFKEUZE",
        "FRAME": "FRAME",
        "FOOTRING": "VOETENRING",
        "ARM RESTS": "ARMSTEUNEN",
      };

      tooltipTranslations = {
        "Select your fabric below from a variety of options, including Cura, Extreme, Select, Capture, Paloma Leather, or Elmosoft Leather.":
          "Maak hieronder uw stofkeuze uit verschillende opties, waaronder Cura, Extreme, Select, Capture, Paloma leder of Elmosoft leder.",
        "Which gas lift should I choose?": "Welke gaslift moet ik kiezen?",
      };

      optionTranslations = {
        "Choose your fabric": "Kies uw stof",
        "Select (Gabriel) - Wool": "Select (Gabriel) - Wol",
        "Capture (Gabriel) - Wool": "Capture (Gabriel) - Wol",
        "Focus (Melange) (Gabriel) - Wool": "Focus (Melange) (Gabriel) - Wol",
        "Mainline Flax (Camira) - Wool": "Mainline Flax (Camira) - Wol",
        "PUxx 1 (Oniro) - Synthetic Leather": "PUxx 1 (Oniro) - Kunstleder",
        "Sirdal (GU) - Wool": "Sirdal (GU) - Wol",
        "Steelcut (Kvadrat) - Wool": "Steelcut (Kvadrat) - Wol",
        "Sisu (Kvadrat) - Wool": "Sisu (Kvadrat) - Wol",
        "Paloma Soft (Wollsdorf) - Leather": "Paloma Soft (Wollsdorf) - Leder",
        "Elmosoft (Elmo) - Leather": "Elmosoft (Elmo) - Leder",
      };

      ppdataTranslations = {
        "Wheels for hard floors": "Wielen voor harde vloeren",
        "Wheels for soft floors": "Wielen voor zachte vloeren",
        "Glides": "Glijders",
        "Universal Wheels": "Universele wielen",
        "No": "Zonder",
        "Yes": "Met voetring",
        "No Arm rests": "Geen armsteunen",
        "Arm rests / Stable": "Armsteunen / Stabiel",
        "Arm rests / Swingback": "Armsteunen / Swingback",
        "3D Arm rests / Stable": "3D-Armsteunen / Stabiel",
        "3D Arm rests / Swingback": "3D-Armsteunen / Swingback",
      };

      dropdownTranslations = {
        "No": "Zonder",
        "Yes": "Ja",
      };

      buttonTranslations = {
        "DESIGN YOUR OWN": "CONFIGUREER",
        "Back to Original Product": "Terug",
      };

      frameColorTranslations = {
        "Black": "Zwart",
        "White": "Wit",
        "Silver": "Zilver",
        "Blush Rose": "Blush Rose",
        "Moss Grey": "Moss Grey",
        "Polished Alu": "Gepolijst alu",
      };
    } else if (lang.startsWith("fr")) {
      // French translations.
      labelTranslations = {
        "COLOUR PLASTIC": "COLORIS PLASTIQUE",
        "GAS LIFT": "VÉRIN À GAZ",
        "WHEELS": "ROULETTES",
        "FABRIC": "CHOIX DE TISSU",
        "FRAME": "COLORIS METAL",
        "FOOTRING": "REPOSE-PIEDS",
        "ARM RESTS": "ACCOUDOIRS",
      };

      tooltipTranslations = {
        "Select your fabric below from a variety of options, including Cura, Extreme, Select, Capture, Paloma Leather, or Elmosoft Leather.":
          "Sélectionnez votre tissu parmi une variété d'options, y compris Cura, Extreme, Select, Capture, Paloma Leather ou Elmosoft Leather.",
        "Which gas lift should I choose?": "Quel vérin à gaz choisir ?",
      };

      optionTranslations = {
        "Choose your fabric": "Choisissez votre tissu",
        "Select (Gabriel) - Wool": "Select (Gabriel) - Laine",
        "Capture (Gabriel) - Wool": "Capture (Gabriel) - Laine",
        "Focus (Melange) (Gabriel) - Wool": "Focus (Melange) (Gabriel) - Laine",
        "Mainline Flax (Camira) - Wool": "Mainline Flax (Camira) - Laine",
        "PUxx 1 (Oniro) - Synthetic Leather": "PUxx 1 (Oniro) - Cuir synthétique",
        "Sirdal (GU) - Wool": "Sirdal (GU) - Laine",
        "Steelcut (Kvadrat) - Wool": "Steelcut (Kvadrat) - Laine",
        "Sisu (Kvadrat) - Wool": "Sisu (Kvadrat) - Laine",
        "Paloma Soft (Wollsdorf) - Leather": "Paloma Soft (Wollsdorf) - Cuir",
        "Elmosoft (Elmo) - Leather": "Elmosoft (Elmo) - Cuir",
      };

      ppdataTranslations = {
        "Wheels for hard floors": "Roulettes sols durs",
        "Wheels for soft floors": "Roulettes pour tapis",
        "Glides": "Patins",
        "Universal Wheels": "Roulettes universelles",
        "No": "Sans",
        "Yes": "Avec repose-pieds",
        "No Arm rests": "Sans accoudoirs",
        "Arm rests / Stable": "Accoudoirs / Stables",
        "Arm rests / Swingback": "Accoudoirs / Swingback",
        "3D Arm rests / Stable": "Accoudoirs 3D / Stables",
        "3D Arm rests / Swingback": "Accoudoirs 3D / Swingback",
      };

      dropdownTranslations = {
        "No": "Sans",
        "Yes": "Oui",
      };

      buttonTranslations = {
        "DESIGN YOUR OWN": "CONFIGUREZ",
        "Back to Original Product": "Retour",
      };

      frameColorTranslations = {
        "Black": "Noir",
        "White": "Blanc",
        "Silver": "Argent",
        "Blush Rose": "Blush Rose",
        "Moss Grey": "Moss Grey",
        "Polished Alu": "Alu poli",
      };
    } else if (lang.startsWith("es")) {
      // Spanish translations.
      labelTranslations = {
        "GAS LIFT": "PISTÓN",
        "WHEELS": "RUEDAS",
        "FABRIC": "TAPIZADOS",
        "FRAME": "ACABADOS BASE",
        "FOOTRING": "REPOSAPIÉS",
      };

      tooltipTranslations = {
        "Select your fabric below from a variety of options, including Cura, Extreme, Select, Capture, Paloma Leather, or Elmosoft Leather.":
          "Seleccione su tejido de entre una variedad de opciones, incluyendo Cura, Extreme, Select, Capture, Paloma Leather o Elmosoft Leather.",
        "Which gas lift should I choose?": "¿Qué pistón debo elegir?",
      };

      optionTranslations = {
        "Choose your fabric": "Elija su tejido",
        "Select (Gabriel) - Wool": "Select (Gabriel) - Lana",
        "Capture (Gabriel) - Wool": "Capture (Gabriel) - Lana",
        "Focus (Melange) (Gabriel) - Wool": "Focus (Melange) (Gabriel) - Lana",
        "Mainline Flax (Camira) - Wool": "Mainline Flax (Camira) - Lana",
        "PUxx 1 (Oniro) - Synthetic Leather": "PUxx 1 (Oniro) - Cuero sintético",
        "Sirdal (GU) - Wool": "Sirdal (GU) - Lana",
        "Steelcut (Kvadrat) - Wool": "Steelcut (Kvadrat) - Lana",
        "Sisu (Kvadrat) - Wool": "Sisu (Kvadrat) - Lana",
        "Paloma Soft (Wollsdorf) - Leather": "Paloma Soft (Wollsdorf) - Cuero",
        "Elmosoft (Elmo) - Leather": "Elmosoft (Elmo) - Cuero",
      };

      ppdataTranslations = {
        "Wheels for hard floors": "Ruedas para suelos duros",
        "Wheels for soft floors": "Ruedas para suelos blandos",
        "Glides": "Deslizadores",
        "Universal Wheels": "Ruedas universales",
        "No": "Sin",
        "Yes": "Con reposapiés",
      };

      dropdownTranslations = {
        "No": "Sin",
        "Yes": "Sí",
      };

      buttonTranslations = {
        "DESIGN YOUR OWN": "DISEÑA EL TUYO",
        "Back to Original Product": "Volver al producto original",
      };

      // Leave frameColorTranslations null for now (keeps English)
      frameColorTranslations = null;
    }

    function replaceFirstTextInElement(elem, translationsMap) {
      if (!translationsMap) return;
      if (elem.childNodes.length > 0 && elem.childNodes[0].nodeType === Node.TEXT_NODE) {
        var originalText = elem.childNodes[0].textContent;
        var trimmedText = originalText.trim();
        if (translationsMap.hasOwnProperty(trimmedText)) {
          var leadingSpaces = originalText.match(/^\s*/)[0];
          var trailingSpaces = originalText.match(/\s*$/)[0];
          elem.childNodes[0].textContent = leadingSpaces + translationsMap[trimmedText] + trailingSpaces;
        }
      }
    }

    function replaceTextNodesInElement(elem, translationsMap) {
      if (!translationsMap) return;
      elem.childNodes.forEach(function (child) {
        if (child.nodeType === Node.TEXT_NODE) {
          var originalText = child.textContent;
          var trimmedText = originalText.trim();
          if (trimmedText.length > 0 && translationsMap.hasOwnProperty(trimmedText)) {
            var leadingSpaces = originalText.match(/^\s*/)[0];
            var trailingSpaces = originalText.match(/\s*$/)[0];
            child.textContent = leadingSpaces + translationsMap[trimmedText] + trailingSpaces;
          }
        }
      });
    }

    function replaceButtonText() {
      if (!buttonTranslations) return;
      document.querySelectorAll("button.ptc_button").forEach(function (button) {
        var originalText = button.textContent.trim();
        if (buttonTranslations.hasOwnProperty(originalText)) {
          button.textContent = buttonTranslations[originalText];
        }
      });
    }

    // Translate frame color swatches only (no data-val changes)
    function translateFrameColors() {
      if (!frameColorTranslations) return;

      document
        .querySelectorAll('.pplr-swatch-element.pplrimage[name="properties[FRAME]"]')
        .forEach(function (swatch) {
          var val = swatch.getAttribute("data-val"); // "Black", "White", ...
          var translated = frameColorTranslations[val];
          if (!translated) return;

          // Visible label
          var labelSpan = swatch.querySelector(".ppdata");
          if (labelSpan) {
            labelSpan.textContent = translated;
          }

          // Tooltip text
          var tooltipSpan = swatch.querySelector(".swtooltip span:last-child");
          if (tooltipSpan) {
            tooltipSpan.textContent = translated;
          }
        });
    }

    // translate tooltip <a> link text + update href for ALL languages (safe: no innerHTML)
    function translateTooltipLinks() {
      // Map <html lang=".."> to Shopify URL prefix
      // Adjust if your site uses different prefixes.
      var langPrefix =
        lang.startsWith("de") ? "/de" :
        lang.startsWith("nl") ? "/nl" :
        lang.startsWith("fr") ? "/fr" :
        lang.startsWith("es") ? "/es" :
        "";

      document.querySelectorAll(".ptooltiptext a").forEach(function (a) {
        var href = a.getAttribute("href") || "";
        var txt = (a.textContent || "").trim();

        // Target only the gas lift guide link (any language)
        if (!href.includes("/pages/hag-capisco-gas-lift-guide")) return;

        // Translate anchor text
        if (tooltipTranslations && tooltipTranslations[txt]) {
          a.textContent = tooltipTranslations[txt];
        }

        // Fix href prefix for ALL languages
        if (!langPrefix) return;

        // Normalize to a pathname (handles absolute URLs too)
        var path = href;
        try {
          if (href.startsWith("http://") || href.startsWith("https://")) {
            path = new URL(href).pathname;
          }
        } catch (e) {
          path = href;
        }

        // Remove any existing language prefix to avoid /de/de/...
        path = path.replace(/^\/(de|nl|fr|es)\//, "/");

        // Ensure it starts with /
        if (!path.startsWith("/")) path = "/" + path;

        // Apply correct prefix
        a.setAttribute("href", langPrefix + path);
      });
    }

    // Translate "Back to Original Product" when it appears inside <a> swatches (not a button)
    function translateMiscTexts() {
      if (!buttonTranslations) return;
      document.querySelectorAll(".pplr-swatch-element span").forEach(function (span) {
        var t = (span.textContent || "").trim();
        if (buttonTranslations[t]) {
          span.textContent = buttonTranslations[t];
        }
      });
    }

function translateCartPropertyNames() {
  if (!labelTranslations) return;
  document.querySelectorAll('[pplr_item_prop_name]').forEach(function (span) {
    var originalText = span.textContent;
    var trimmedText = originalText.trim();
    if (labelTranslations.hasOwnProperty(trimmedText)) {
      var leadingSpaces = originalText.match(/^\s*/)[0];
      var trailingSpaces = originalText.match(/\s*$/)[0];
      span.textContent = leadingSpaces + labelTranslations[trimmedText] + trailingSpaces;
    }
  });
}

    function replaceAllTranslations() {
      document.querySelectorAll(".pplrlabel").forEach(function (elem) {
        replaceFirstTextInElement(elem, labelTranslations);
      });

      // This translates tooltips that are plain text nodes.
      document.querySelectorAll(".ptooltiptext").forEach(function (elem) {
        replaceFirstTextInElement(elem, tooltipTranslations);
      });

      document.querySelectorAll("option").forEach(function (elem) {
        var text = elem.textContent.trim();
        if (optionTranslations && optionTranslations.hasOwnProperty(text)) {
          elem.textContent = optionTranslations[text];
        }
      });

      document.querySelectorAll(".ppdata").forEach(function (elem) {
        var originalText = elem.textContent;
        var trimmedText = originalText.trim();
        if (ppdataTranslations && ppdataTranslations.hasOwnProperty(trimmedText)) {
          var newText = ppdataTranslations[trimmedText];
          elem.textContent = newText;
          var parent = elem.closest("[data-val]");
          if (parent) {
            parent.setAttribute("data-val", newText);
            var tooltipSpan = parent.querySelector(".swtooltip span");
            if (tooltipSpan && tooltipSpan.textContent.trim() === trimmedText) {
              tooltipSpan.textContent = newText;
            }
          }
        }
      });

      document.querySelectorAll(".pplr-selecter-selected.dropdowncolor").forEach(function (elem) {
        replaceTextNodesInElement(elem, dropdownTranslations);
      });

      replaceButtonText();
      translateFrameColors();

      // Handle <a> inside tooltip (gas lift) + localized link
      translateTooltipLinks();

      // Handle "Back to Original Product" inside <a> swatches
      translateMiscTexts();
      translateCartPropertyNames();
    }

    // Run once on load
    replaceAllTranslations();

    // MutationObserver – optimized for Dawn: only watch the configurator, with debounce
    var target = document.querySelector(".pplr-wrapper") || document.body;
    var pending = false;

    var observer = new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () {
        replaceAllTranslations();
        pending = false;
      });
    });

    observer.observe(target, { childList: true, subtree: true });
  }
});
